import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';

const locationPropertyTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func,
  tabIndex: PropTypes.number,
  focusable: PropTypes.bool,
};

type LocationProperties = PropTypes.InferProps<typeof locationPropertyTypes> & {
  fill?: string;
  width?: number;
  height?: number;
  className?: string;
  onClick?: () => void;
  tabIndex?: number;
  focusable?: boolean;
};

const Location = (properties: LocationProperties) => (
  <Icon
    // eslint-disable-next-line max-len
    dPath="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
    title="Location"
    fill="var(--grey-dark)"
    {...properties}
  />
);

Location.propTypes = locationPropertyTypes;

export default Location;
